import { BufferAttribute, BufferGeometry, DoubleSide, Points, PointsMaterial } from "three";
import { SceneGraphNode } from "../internal";
/**
 * Creates a simple pointcloud
 * @class SimplePointCloud
 * @param {number[]} coordinates position of box in lv95 [m]
 * @param {number} size - the sidelength in [m]
 * @extends {SceneGraphNode}
 * @constructor
 */
export class SimplePointCloud extends SceneGraphNode {
    constructor(coordinates) {
        super(null);
        this.coordinates = coordinates;
    }
    init(traversalState) {
        super.init(traversalState);
        const engine = traversalState.scene.engine;
        const geometry = new BufferGeometry();
        const positions = new Float32Array(this.coordinates.length * 3);
        const colors = new Float32Array(this.coordinates.length * 3);
        for (let i = 0; i < this.coordinates.length; i++) {
            const x = this.coordinates[i][0] - engine.centroid[0];
            const y = this.coordinates[i][1] - engine.centroid[1];
            const z = this.coordinates[i][2] - engine.centroid[2];
            positions[i * 3] = x;
            positions[i * 3 + 1] = y;
            positions[i * 3 + 2] = z;
            colors[i * 3] = this.coordinates[i][3];
            colors[i * 3 + 1] = this.coordinates[i][4];
            colors[i * 3 + 2] = this.coordinates[i][5];
        }
        geometry.setAttribute("position", new BufferAttribute(positions, 3));
        geometry.setAttribute("color", new BufferAttribute(colors, 3));
        geometry.computeBoundingSphere();
        const material = new PointsMaterial({
            size: 4,
            side: DoubleSide,
            vertexColors: true,
            sizeAttenuation: false,
            transparent: true,
            opacity: 0.1,
        });
        this.iMesh = new Points(geometry, material);
    }
    /**
     * Changes color to green
     * @method highlight
     */
    highlight() {
        return;
    }
    /**
     * Changes color to red
     * @method unhighlight
     */
    unhighlight() {
        return;
    }
}
//# sourceMappingURL=simplepointcloud.js.map